module.exports = __webpack_public_path__ + "media/images/banner/wowjapan/ja-7a8435e077826f0defd827b210b36f91.jpg";